import { BaseDTO } from './basedto';

export class DeletePackageEngineerAssignmentDTO extends BaseDTO {
    ids: number[];
    constructor() {
        super();
        this.ids = [];
    }
}
